export const methodology = {
  "methodology_components": [
    {
      "component": "Academic Rankings",
      "weight": 25,
      "description": "Analysis of global and national university rankings",
      "data_sources": [
        "QS Rankings",
        "Times Higher Education",
        "Academic Ranking of World Universities"
      ],
      "reliability_score": 85,
      "methodology": "Standardized ranking criteria including academic reputation, research output, and international outlook"
    },
    {
      "component": "Student Satisfaction",
      "weight": 20,
      "description": "Analysis of student satisfaction and learning experience",
      "data_sources": [
        "National Student Survey",
        "Student Reviews",
        "Alumni Feedback"
      ],
      "reliability_score": 80,
      "methodology": "Survey-based assessment of teaching quality, student support, and overall experience"
    },
    {
      "component": "Employment Outcomes",
      "weight": 20,
      "description": "Analysis of graduate employment rates and career success",
      "data_sources": [
        "Graduate Outcomes Survey",
        "Employment Reports",
        "Alumni Career Data"
      ],
      "reliability_score": 82,
      "methodology": "Tracking of graduate employment rates, salary data, and career progression"
    },
    {
      "component": "Research Quality",
      "weight": 15,
      "description": "Assessment of research output and academic excellence",
      "data_sources": [
        "Research Excellence Framework",
        "Citation Analysis",
        "Publication Metrics"
      ],
      "reliability_score": 88,
      "methodology": "Quantitative analysis of research publications, citations, and impact factors"
    },
    {
      "component": "Financial Analysis",
      "weight": 10,
      "description": "Analysis of tuition fees, ROI, and financial accessibility",
      "data_sources": [
        "University Financial Reports",
        "Student Finance Data",
        "ROI Studies"
      ],
      "reliability_score": 75,
      "methodology": "Cost-benefit analysis of tuition fees versus expected career outcomes"
    },
    {
      "component": "International Recognition",
      "weight": 10,
      "description": "Assessment of global reputation and international standing",
      "data_sources": [
        "International Rankings",
        "Global Reputation Surveys",
        "Academic Networks"
      ],
      "reliability_score": 78,
      "methodology": "Analysis of international reputation, global partnerships, and academic networks"
    }
  ],
  "overall_methodology": {
    "title": "Comprehensive University Analysis Methodology",
    "description": "Multi-dimensional approach combining quantitative rankings, qualitative assessments, and real-world outcomes",
    "total_weight": 100,
    "confidence_level": "High",
    "last_updated": "2025",
    "methodology_version": "v4.0"
  },
  "data_quality_metrics": {
    "data_freshness": "Real-time",
    "source_diversity": "Multiple authoritative sources",
    "verification_process": "Cross-referenced with official university data",
    "transparency_score": 90,
    "methodology_transparency": "Full disclosure of criteria and weighting"
  },
  "recommendations": [
    {
      "category": "methodology_improvement",
      "issue": "Enhanced real-time data integration",
      "recommendation": "Integrate more real-time data sources for up-to-date analysis",
      "priority": "Medium",
      "expected_impact": "Improved accuracy and timeliness of analysis"
    },
    {
      "category": "methodology_improvement",
      "issue": "Student feedback integration",
      "recommendation": "Increase weight of student satisfaction metrics",
      "priority": "High",
      "expected_impact": "Better representation of student experience"
    }
  ],
  "tab_name": "methodology",
  "data": [
    {
      "name": "Academic Rankings",
      "series": [
        {
          "name": "Weight",
          "value": 25
        },
        {
          "name": "Reliability",
          "value": 85
        }
      ]
    },
    {
      "name": "Student Satisfaction",
      "series": [
        {
          "name": "Weight",
          "value": 20
        },
        {
          "name": "Reliability",
          "value": 80
        }
      ]
    },
    {
      "name": "Employment Outcomes",
      "series": [
        {
          "name": "Weight",
          "value": 20
        },
        {
          "name": "Reliability",
          "value": 82
        }
      ]
    },
    {
      "name": "Research Quality",
      "series": [
        {
          "name": "Weight",
          "value": 15
        },
        {
          "name": "Reliability",
          "value": 88
        }
      ]
    },
    {
      "name": "Financial Analysis",
      "series": [
        {
          "name": "Weight",
          "value": 10
        },
        {
          "name": "Reliability",
          "value": 75
        }
      ]
    },
    {
      "name": "International Recognition",
      "series": [
        {
          "name": "Weight",
          "value": 10
        },
        {
          "name": "Reliability",
          "value": 78
        }
      ]
    }
  ],
  "evidence_sources": [],
  "cached": false,
  "timestamp": "2025-08-29T22:23:50.126401",
  "models_used": [
    "gpt-4o-mini"
  ],
  "plan_type": "university_paid",
  "metadata": {
    "analysis_type": "methodology_analysis",
    "country": "UK",
    "total_universities": 2,
    "course": "MBA",
    "response_time": 16.03,
    "model_meta": {
      "model_used": "gpt-4o-mini",
      "analysis_engine": "methodology_analysis_v1",
      "web_search_used": false
    }
  }
};

